import './index.scss'
import React from 'react'
import { Card, Space, Flex, Popover, Skeleton, Dropdown } from 'antd'
import { MoreOutlined, ClockCircleOutlined } from '@ant-design/icons'
import ImageBox from '@/components/ImageBox'
import ModelAction from '@/views/components/ModelAction'
import UserAvatar from '@/components/UserAvatar'
import UserPopup from '@/views/components/UserPopup'

const ModelItem = ({ item, onDropdownClick, avatar = true, showTime = false, timeLabel = '上传时间' }) => {
  
  // 格式化时间显示
  const formatTime = (timeStr) => {
    if (!timeStr) return ''
    const date = new Date(timeStr)
    const now = new Date()
    const diff = now - date
    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    
    if (days === 0) {
      const hours = Math.floor(diff / (1000 * 60 * 60))
      if (hours === 0) {
        const minutes = Math.floor(diff / (1000 * 60))
        return minutes <= 0 ? '刚刚' : `${minutes}分钟前`
      }
      return `${hours}小时前`
    } else if (days < 7) {
      return `${days}天前`
    } else {
      return date.toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' })
    }
  }

  return (
    <div className="model-card-wrapper">
      <Card
        className="model-card"
        style={{ cursor: "pointer" }}
        cover={
          <>
            <ImageBox
              src={ item.modelImgUrl }
              loading={ item.loading }
            />
            {/* 草稿标签 - 左上角 */}
            {item.status === 0 && (
              <div className="model-status">
                <div className="model-status-text">
                  <span>草稿</span>
                </div>
              </div>
            )}
            {/* 操作按钮 - 右上角，hover显示 */}
            {!item.loading && onDropdownClick && (
              <div 
                className="model-card-actions"
                onClick={(e) => e.stopPropagation()}
              >
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: "move",
                        label: <span>移动至</span>,
                      },
                      {
                        key: "delete",
                        label: <span style={{ color: '#ff4d4f' }}>删除</span>,
                      }
                    ],
                    onClick: ($event) => onDropdownClick($event, item)
                  }}
                  trigger={['click']}
                >
                  <div className="action-trigger">
                    <MoreOutlined />
                  </div>
                </Dropdown>
              </div>
            )}
          </>
        }
        onClick={() => {
          item.id && window.open(`/detail/${ item.id }`)
        }}
      >
        <Skeleton
          className="skeleton-userinfo"
          avatar={ false }
          title={ true }
          paragraph={ true }
          active={ true }
          loading={ item.loading }
        >
          {/* 单行布局：用户头像 + 模型名称 + 社交数据 */}
          <Flex align="center" gap={0} className="model-info-row">
            {/* 左侧：用户头像 - 所有页面都显示（如果有userCard和avatar=true） */}
            {item.userCard && avatar && (
              <Popover
                overlayClassName="user-popover"
                placement="bottomLeft"
                content={ <UserPopup data={ item.userCard } /> }
              >
                <div
                  className="user-avatar-wrapper"
                  onClick={(e) => {
                    e.stopPropagation()
                    window.open(`/user/creator/${item.userCard.id}`)
                  }}
                >
                  <UserAvatar size={ 32 } avatar={ item.userCard.avatar } />
                </div>
              </Popover>
            )}

            {/* 中间：模型名称 - 支持滚动 */}
            <div className="model-title-container">
              <div className="model-title-scroll" title={ item.modelName }>
                <span className="model-title-text">{item.modelName}</span>
                {/* 如果名称过长，复制一份用于无缝滚动 */}
                {item.modelName && item.modelName.length > 12 && (
                  <span className="model-title-text">{item.modelName}</span>
                )}
              </div>
            </div>

            {/* 右侧：社交数据 */}
            <div className="model-actions-wrapper">
              <ModelAction
                actionType={ ['浏览', '点赞', '收藏'] }
                model={ item }
                readonly={ true }
              />
            </div>
          </Flex>

          {/* 时间信息 - 底部 */}
          {showTime && item.createTime && (
            <div className="model-time-info">
              <ClockCircleOutlined className="time-icon" />
              <span className="time-label">{timeLabel}:</span>
              <span className="time-value">{formatTime(item.createTime)}</span>
            </div>
          )}
        </Skeleton>
      </Card>
    </div>
  )
}

export default React.memo(ModelItem)
